export default "__VITE_ASSET__COKUi3HD__"